module.exports = __webpack_public_path__ + "img/share.552d8c6.png";